import React from 'react';
import CardHeader from "../../components/Card/CardHeader";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import LabSolutionsTable from "./LabSolutionsTable";

export default function LabSolutions() {
    const classes = {};

    return (
        <GridContainer>
            <GridItem>
                <Card>
                    <CardHeader>
                        <h4 className={classes.cardTitle}>LAB Solutions</h4>
                    </CardHeader>
                    <CardBody>
                        <GridContainer>
                            <GridItem>
                            </GridItem>
                        </GridContainer>
                        <GridContainer>
                            <GridItem>
                                <LabSolutionsTable/>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );
}
